export const SMS = 'SMS';
export const EMAIL = 'EMAIL';
export const PUSH = 'PUSH';
